<div class="card">
    <div class="card-body">
        <div class="container">
            <div class="px-4" style="text-align: justify;">
                <h3 class="mb-4 mt-5">COOKIE POLICY</h3>
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">1. INTRODUCTION</h4>
                    <p>
                        Welcome to <b>www.microshipments.com</b> by <b>VALUESHIPR</b> , an E-commerce 
                        Platform, operating in India through its <b>Franchisee M/s. Decker Logistics Pvt. 
                        Ltd.</b> having its registered office at Unit No. 123, Adarsh Industrial Estate, Sahar Road, Andheri East, Mumbai  Pin - 400 099, (hereinafter referred to as 
                        "we," "us," or "our"). <b>www.microshipments.com</b> is a website utilised to e-book 
                        air shipments below 500Kgs. We use <b>cookies and similar tracking 
                        technologies</b> on our <b>website</b>, through which you can e-book air shipments below 
                        500Kgs, to improve functionality, enhance user experience and provide 
                        personalised services. 
                    </p>
                    <p>
                        This Cookie Policy explains: 
                            <span class="d-block ps-3">1. What cookies are and why we use them.</span>
                            <span class="d-block ps-3">2. The types of cookies we use.</span>
                            <span class="d-block ps-3">3. How you can manage cookie preferences.</span>
                    </p>
                    <p>
                        By accessing and using our website, you hereby <b>consent to the use of cookies</b>  
                        in accordance with the terms of this policy. If you do not agree to such use, you 
                        may modify your browser settings accordingly or cease using our website. 
                    </p>
                </div>
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">2. WHAT ARE COOKIES?</h4>
                    <p>Cookies are small text files placed on your device (computer, smartphone, or tablet) when you visit a website. They are widely used to enhance website performance, store preferences, and provide insights to website owners.</p>
                    <p>Cookies can be categorised as follows:</p>
                    <p class="ps-3"><b>(a) Session cookies:</b> Temporary cookies that are deleted when you close your browser.</p>
                    <p class="ps-3"><b>(b) Persistent cookies:</b> Cookies that remain on your device for a set period or until deleted manually.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">3. TYPES OF COOKIES WE USE</h4>
                    <p>We use the following types of cookies on our website:                    </p>
                
                    <h6 class="mt-3">3.1 Essential cookies</h6>
                    <p>These cookies are necessary for our website to function properly. They enable core functionalities such as secure login, booking confirmations, and payment processing. Blocking these cookies may affect site functionality.</p>
                
                    <h6 class="mt-3">3.2 Performance cookies</h6>
                    <p>These cookies collect anonymous data about how visitors use our website, such as the most visited pages and browsing patterns. This helps us analyse website performance and improve user experience.</p>
                
                    <h6 class="mt-3">3.3 Functional cookies</h6>
                    <p>These cookies allow our website to remember your preferences (e.g., language, region) and provide an improved user experience.</p>
                
                    <h6 class="mt-3">3.4 Marketing cookies</h6>
                    <p>These cookies track browsing habits and help deliver targeted advertisements based on your interests. They may also measure the effectiveness of advertising campaigns.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">4. THIRD-PARTY COOKIES</h4>
                    <p>4.1 We may allow third-party service providers to place cookies on your device for the following purposes:</p>
                    <p class="ps-4"><b>(a) Analytics (e.g., Google Analytics):</b> To analyse traffic and website usage.</p>
                    <p class="ps-4"><b>(b) Advertising (e.g., Facebook Pixel):</b> To deliver targeted ads and measure their effectiveness.</p>
                    <p class="ps-4"><b>(c) Social media Integration (e.g., Twitter, LinkedIn):</b> To enable content sharing on social media platforms.</p>
                    <p>4.2 These third parties have their own privacy policies and cookie practices. We <b>do not control</b> the use of these cookies and recommend reviewing their respective policies.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">5. HOW WE USE COOKIES</h4>
                    <p>We use cookies for the following purposes:</p>
                    <p class="ps-4"><b>(a) Authentication and Security:</b> To enable secure login and fraud prevention.</p>
                    <p class="ps-4"><b>(b) Booking and Payment Processing:</b> To facilitate shipment booking transactions.</p>
                    <p class="ps-4"><b>(c) User Preferences:</b> To remember your settings and improve website usability.</p>
                    <p class="ps-4"><b>(d) Website Analytics:</b> To track performance and enhance functionality.</p>
                    <p class="ps-4"><b>(e) Advertising and Marketing:</b> To personalise content and serve relevant ads.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">6. YOUR CHOICES REGARDING COOKIES</h4>
                    <p>You have the following options to manage or disable cookies:</p>
                
                    <p>6.1 <b>Browser settings</b></p>
                    <p>Most web browsers allow you to control cookies through their settings. You can:</p>
                    <p class="ps-4">(a) <b>Block all cookies</b> or specific types of cookies.</p>
                    <p class="ps-4">(b) <b>Delete existing cookies</b> stored on your device.</p>
                    <p class="ps-4">(c) <b>Receive alerts </b>before a cookie is placed on your device.</p>
                    <p><i>Note: Disabling cookies may affect website functionality.</i></p>

                <p>6.2 <b>Cookie Management Tool</b></p>
                    <p>We provide a <b>cookie management tool</b> on our website that allows you to customise your cookie preferences. 
                       You can <b>enable or disable</b> specific categories of cookies (e.g., performance, marketing) using this tool.</p>
                
                <p>6.3 <b>Opt-Out Of Targeted Advertising</b></p>
                    <p>To opt out of targeted advertising, visit the following platforms:</p>
                    <p class="ps-4">(a) <u>Your Online Choices (EU)</u></p>
                    <p class="ps-4">(b) <u>Network Advertising Initiative (NAI)</u></p>
                    <p class="ps-4">(c) <u>Digital Advertising Alliance (DAA)</u></p>
                </div>
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">7. DATA SECURITY</h4>
                    <p>We take the security of your data seriously and implement <b>industry-standard security measures</b> to protect it. 
                        Cookies <b>do not store sensitive personal information</b> such as payment details, which are securely processed through 
                        third-party payment gateways.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">8. CHANGES TO THIS COOKIE POLICY</h4>
                    <p>We reserve the right to amend or update this Cookie Policy at any time. Any material changes shall be communicated 
                        through our website or via email notifications. Continued use of our website following the implementation of such 
                        changes shall constitute your acceptance of the revised policy.</p>
                </div>
                
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">9. DISPUTES,ARBITRATION,AND GOVERNING LAW</h4>
                    <p>9.1 If you have concerns regarding our use of cookies, you may contact our customer support team to resolve the issue.</p>
                
                    <p>9.2 In the event that the dispute remains unresolved, the matter shall be referred to <b>Arbitration</b>, in accordance with 
                        the provisions of the Arbitration and Conciliation Act, 1996 as amended from time to time.</p>
                
                    <p>9.3 The arbitration shall be conducted by a Sole Arbitrator appointed mutually by both parties. If the parties cannot 
                        agree on an arbitrator, the arbitrator shall be appointed by a competent authority under the Act.</p>
                
                    <p>9.4 The seat and venue of arbitration shall be Mumbai, India. The arbitration proceedings shall be conducted in the 
                        English language and the decision of the arbitrator shall be final, conclusive, and binding upon both parties. 
                        No appeal shall lie therefrom, except as provided under the applicable law.</p>
                </div>
                <div class="mb-3">
                    <h4 class="mt-4 mb-3">10. CONTACT US</h4>
                    <p>
                        <span class="d-block mt-2">If you have any questions or concerns about this Cookie Policy or our use of cookies, please contact us at:</span>
                        <span class="d-block mt-2 ps-3"><b><i><a href="http://www.microshipments.com/">www.microshipments.com</a></i></b> by <b>Valueshipr</b></span>
                        <span class="d-block ps-3 mt-3"><b>Decker Logistics Private Limited</b></span>
                        <span class="d-block ps-3">Unit No. 123, Adarsh Industrial Estate, Sahar Road,</span>
                        <span class="d-block ps-3">Andheri East, Mumbai 400099</span>
                        <span class="d-block ps-3 mt-3"><b>Phone: +91 9167 226 158</b></span>
                        <span class="d-block ps-3 mt-3"><b>Email: support@valueshipr.com</b></span>
                      
                    </p>
                </div>                    
            </div>
        </div>
    </div>
</div>